import { PrismLoadingBar } from '@mylighthouse/prism-ember';

<template><PrismLoadingBar @isFixed={{true}} @positionTop={{60}} /></template>
